import css from './audioplayer.module.css'

export default function AudioPlayer({ audio }) {
  return(
    <audio controls src={audio} className={css.audioPlayer}/>
  );
}